import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

class CategoriesService {
  async list({ page = 0, limit = 10, search = '' } = {}) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.CATEGORIES.LIST, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async userList({ page = 0, limit = 10, search = '' } = {}) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.CATEGORIES.USER_LIST, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async dropdown() {
    try {
      const res = await axiosInstance.get(ENDPOINTS.CATEGORIES.DROPDOWN);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async create(payload) {
    try {
      const res = await axiosInstance.post(ENDPOINTS.CATEGORIES.CREATE, payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async update(uuid, payload) {
    try {
      const res = await axiosInstance.put(ENDPOINTS.CATEGORIES.UPDATE(uuid), payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async view(uuid) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.CATEGORIES.VIEW(uuid));
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async setStatus(uuid, isActive) {
    try {
      const res = await axiosInstance.put(
        ENDPOINTS.CATEGORIES.STATUS_UPDATE(uuid),
        { is_active: isActive }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}

const categoriesService = new CategoriesService();
export default categoriesService;
